<template>
  <div class="overall-bg p-0 position-relative">
    <div class="tabviewtable">
      <TabView class="tabview-custom" ref="tabview4" :scrollable="true">
        <TabPanel>
          <template #header>
            <span>{{ $t("invtabs.issue") }}</span>
          </template>
          <div>
            <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
              <div class="">
                <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
                  <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                  <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                  </span>
                </div>
                <div class="filter_chip" v-if="filterItemsArray[0]['issueCode'] !== ''">
                  <span>Issue code: {{ filterItemsArray[0]["issueCode"] }}</span>
                  <span @click="removeChip('issueCode')"><i class="pi pi-times"></i>
                  </span>
                </div>
                <div class="filter_chip" v-if="filterItemsArray[0]['requestCode'] !== ''">
                  <span>Request code:
                    {{ filterItemsArray[0]["requestCode"] }}</span>
                  <span @click="removeChip('requestCode')"><i class="pi pi-times"></i>
                  </span>
                </div>
                <div class="filter_chip" v-if="filterItemsArray[0]['ToStore'] != ''">
                  <span>Store Name: {{ filterItemsArray[0]["ToStore"] }}</span>
                  <span @click="removeChip('ToStore')"><i class="pi pi-times"></i>
                  </span>
                </div>
                <!-- {{ filterItemsArray }} -->
                <div class="filter_chip" v-if="filterItemsArray[0]['issuebyName'] != ''">
                  <span>Issue By: {{ filterItemsArray[0]["issuebyName"] }}</span>
                  <span @click="removeChip('issuebyName')"><i class="pi pi-times"></i>
                  </span>
                </div>
              </div>
              <div class="">
                <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                  Clear all
                </button>
              </div>
            </div>
            <div class="form-white-bg" v-if="windowWidth > 545">
              <b-row>
                <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                  <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                    <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                      :ClearDateFilter="SearchValue" v-if="FilterLoading">
                      <template v-slot:filterslot>
                        <itemIssueFilter @tostorename="EmitToStore" @tostoreid="EmitToStoreId" :issuesstatus="2"
                          @updatedrequestcode="Emitrequestcode" @updatedissuecode="Emitissuecode" ,
                          @updatedissuedby="Emitissuesby" @toissuename="EmitToissuebyname" :dataList="items"
                          :removechiptype="removechipvalue" />
                      </template>
                    </FilterForm>
                  </b-collapse>
                </b-col>
                <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                  <SkeletonTableLoader :columns="headers" :loading="loading" />
                  <div v-if="!loading">
                    <MasterEmpty :createline="IsAddButton" v-if="
                      items.length === 0 &&
                      !SearchValue.inputValue &&
                      !SearchValue.fromDate &&
                      !SearchValue.toDate
                    " eheader="Item Issue" econtent="Item Issue" eimg="/src/assets/Img/icons/itemmaster.svg"
                      @createNew="IsCreate()" />
                    <Tableview v-if="
                      items.length !== 0 ||
                      SearchValue.inputValue ||
                      SearchValue.fromDate ||
                      SearchValue.toDate
                    " :value="items" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true"
                      filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
                      :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                      :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false"
                      :searchbox1="true" @search="SearchBox" :exceldownload="true" :filterbtn="true"
                      :showColumnFilters="false">
                      <template v-slot:exceldownload>
                        <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                          :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                      </template>
                      <template v-slot:filter>
                        <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                          :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                          @click="visible = !visible"></i>
                      </template>
                      <template v-slot:Add v-if="IsAddButton">
                        <span class="add">
                          <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')">
                          </AddButton>
                        </span>
                      </template>
                      <template v-slot:action="{ data }">
                        <span>
                          <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                            @click="toggle($event, data)" />
                        </span>
                      </template>
                      <template v-slot:DocNo="{ data }">
                        <span>
                          {{ data.DocNo }}
                        </span>
                        <div v-if="data.IsCamp == true && data.Status == 1">
                          <span class="CampIssueClose">(Closed)</span>
                        </div>
                      </template>
                      <template v-slot:RequestIdSlot="{ data }">
                        <span v-if="data.RefNo != ''">
                          {{ data.RefNo }}
                        </span>
                        <span v-else>
                          {{ " - " }}
                        </span>
                        <div v-if="data.IsCamp == true">
                          <span class="CampName">(Camp)</span>
                        </div>
                      </template>
                      <!-- <template v-slot:ApprovalStatus="{ data }">
                        <OrangeStatus name="Pending" v-if="data.IsApproved == '0' || data.IsApproved == '2'" />
                        <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                        <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                      </template> -->
                    </Tableview>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-if="windowWidth <= 545">
              <MobileLoader v-if="loading" v-for="item in 5" />
              <div v-if="!loading">
                <MasterEmpty v-if="
                  items.length === 0 &&
                  !SearchValue.inputValue &&
                  !SearchValue.fromDate &&
                  !SearchValue.toDate
                " eheader="Item Issue" econtent="Item Issue" eimg="/src/assets/Img/icons/itemmaster.svg"
                  @createNew="IsCreate()" />
                <MobileViewCardHeader :totalRecords="rowsCount" :state="state" @search="SearchBox" v-if="
                  items.length !== 0 ||
                  SearchValue.inputValue ||
                  SearchValue.fromDate ||
                  SearchValue.toDate
                ">
                  <template v-slot:mobilecard>
                    <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <p class="light-name">{{ item.DocNo }} /</p>
                          <p class="light-name1">{{ item.RefNo }}</p>
                        </div>
                        <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                      </div>
                      <p class="name">{{ item.ToStoreName }}</p>
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Item count :</p>
                        <p class="small-name">{{ item.ItemCount }}</p>
                      </div>
                    </div>
                  </template>
                </MobileViewCardHeader>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <template #header>
            <span>{{ $t("invtabs.returns") }}</span>
          </template>
          <div>
            <IssueReturnTableView IssueType="InBound" :propsParams="paramValues1" />
          </div>
        </TabPanel>
      </TabView>
    </div>
  </div>
  <Toast />

  <!-- Commenly Used Components -->
  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(DataEdit)" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(DataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <CampCloseConfirmation :Editmodel="CampconfirmModel" @yes="CampClose(DataEdit)" @no="CampconfirmModel = false"
    HeaderContent="Confirm close!" content="Do you want to close?" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <!-- Commenly Used Components -->
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  onUnmounted,
} from "vue";

import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
// import commonService from "../../../../Service/WithoutStockAffectService";
import Service from "../../../../../../../modules/Inventory/Service/StockOutService";
import { useRoute, useRouter } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import CampCloseConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import IssueReturnTableView from "../../../../../../../modules//Inventory/pages/Transaction/StockOut/issuereturn/IssueReturnTableView.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import moment from "moment";
import FilterForm from "../../../../../../../components/FormComponents/FilterForm.vue";
import itemIssueFilter from "../../../../../../../modules/Inventory/components/Filters/itemIssueFilters.vue";
import ExportOption from "../../../../../../../components/FormComponents/Export.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    CampCloseConfirmation,
    DeleteConfirmationVue,
    IssueReturnTableView,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    FilterForm,
    itemIssueFilter,
    ExportOption,
  },

  props: {
    showone: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    propsParams: {
      type: Object,
    },
    Addstatus: {
      type: Boolean,
      Default: true,
    },
    FunctionRights: {
      type: Object,
    },
    IsAddButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["row-click"],
  setup(props, { emit }) {
    let loading = ref(false);
    const datas = ref();
    const menus = ref();
    const menu = ref();
    let FilterLoading = ref(true);
    let visible = ref(false);
    const { t } = useI18n();
    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let TransferFlag = localStorage.getItem("TransferFlag");
    const PrintType = ref({
      Type: "T",
      FormId: 10,
      HeaderTitle: "OutBound Issue",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("OutBound Issue");
    let ExportOption = ref("");

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    /* variable declaration*/
    let issueType = ref({
      Type: "InBound",
    });

    let showitemfield = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const generic = ref();
    let items: any = ref([]);
    let loading1 = ref(false);
    const rowsCount = ref(0);

    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    const toast = useToast();
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    const route = useRoute();
    let Types = route.query.Type;

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    onMounted(() => {
      let loading = ref(false);
      let QueryStringValue: any = route.query;
      ParamValues.value.status = QueryStringValue["status"];

      IsShow();
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;
        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );
    const Activevisible = ref(false);
    const CampClosebtn = ref(false);
    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.RefId == 0) {
        Activevisible.value = true;
      } else {
        Activevisible.value = false;
      }

      if (
        data.ReturnStatus == "7dayspassed" &&
        data.IsCamp == true &&
        data.Status == ""
      ) {
        CampClosebtn.value = true;
      } else {
        CampClosebtn.value = false;
      }
      datas.value = data;
      menus.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Activevisible,
            command: async () => {
              Editdata(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: Activevisible,
            command: async () => {
              Deletedata(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            visible: true,
            command: async () => {
              Print(datas.value);
            },
          },

          {
            label: "Camp issue close",
            icon: "deleteicon pi pi-times-circle",
            visible: CampClosebtn,
            command: async () => {
              ConfirmCampClose(datas.value);
            },
          },
        ],
      },
    ]);

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("storetabdetails.outboundissue.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.outboundissue.Code"),
        field: "DocNo",
        slot: "DocNo",
        class: "smallwidth",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.outboundissue.Date"),
        field: "CreatedAtHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundissue.FromStore"),
        field: "FromStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundissue.ToStore"),
        field: "ToStoreName",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      // {
      //   header: t('storetabdetails.outboundissue.ReqBy'),
      //   field: "ModifiedByName",
      //   bodyclass: "boldclass text_overflow2",
      //   class: "mediumwidth",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },{
      //   header: t('storetabdetails.outboundissue.ReqDate'),
      //   field: "RequestedDate",
      //   bodyclass: "boldclass text_overflow2",
      //   class: "mediumwidth",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },
      {
        header: t("storetabdetails.outboundissue.issueBy"),
        field: "IssuedByName",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.outboundissue.issueDate"),
        field: "IssuedDate",
        class: "mediumwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: t("storetabdetails.outboundissue.ItemCount"),
        field: "ItemCount",
        bodyclass: "boldclass bluecolor right_td",
        class: "smallwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.outboundissue.RequestId"),
        field: "RefNo",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "RequestIdSlot",
        class: "smallwidth",
        fieldDisplay: "false",
      },
      // {
      //   header: t('storetabdetails.outboundissue.Status'),
      //   field: "",
      //   fieldDisplay: "false",
      //   slot: "ApprovalStatus",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "",
      // },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    let ParamValues = ref({
      requestId: "",
      StockOutTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 2,
      status: 0,
      Types: Types,
      StockWOTransTMId: 0,
      EntityId: 0,
      OperationId: 0,
      storebranchmapid: 0,
      ToStoreBrMapId: 0,
      BranchId: 0,
    });

    const paramValues1 = ref({
      Id: "",
      Type: "",
      status: 0,
    });

    let dataValue = {
      Id: "",
      status: "",
      Type: "",
    };

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];

        ParamValues.value.fromStoreId = Number(dataValue.Id);
        ParamValues.value.status = Number(dataValue.status);
        ParamValues.value.Types = String(dataValue.Type);
        IsShow();

        paramValues1.value.Id = dataValue.Id;
        paramValues1.value.Type = String(dataValue.Type);
        paramValues1.value.status = Number(dataValue.status);
      }
    });

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const CampconfirmModel = ref(false);

    const rowFocus = ref(false);
    let DataEdit = ref();
    let StockOutTransId = 0;
    let DocType;

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
      DataEdit.value = event.data
        ? event.data.StockOutTransId
        : event.StockOutTransId;
      router.push({
        path: "/IssueDetails",
        query: {
          id: event.data ? event.data.StockOutTransId : event.StockOutTransId,
          storeid: ParamValues.value.fromStoreId,
        },
      });
    }

    function Editdata(data) {
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        debugger;
        DataEdit.value = data;
        StockOutTransId = data.StockOutTransId;
        DocType = data.DocType;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function Deletedata(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        DataEdit.value = data;
        StockOutTransId = data.StockOutTransId;
        DocType = data.DocType;
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function ConfirmCampClose(data) {
      debugger;
      DataEdit.value = data;
      StockOutTransId = data.StockOutTransId;
      CampconfirmModel.value = true;
    }

    const globalFilterFields = ref(headers.map((col) => col.field));

    let QueryStringValue3: any = route.query;
    ParamValues.value.fromStoreId = QueryStringValue3["Id"];

    const IsCreate = () => {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      ParamValues.value.EntityId = ObjOperationId.value.EntityId;
      ParamValues.value.OperationId = ObjOperationId.value.CreateId;
      ParamValues.value.storebranchmapid = Number(
        routes.query.storebranchmapid
      );
      ParamValues.value.BranchId = Number(routes.query.BranchId);

      if (permissionResult.hasPermission) {
        router.push({
          path: "/Issue",

          query: {
            data: JSON.stringify(ParamValues.value),
            param: "DirectIssue",
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsEdit(DataEdit) {
      debugger;

      console.log(DataEdit["DocNo"]);
      ParamValues.value.requestId = DataEdit["DocNo"];
      ParamValues.value.StockOutTransTMId = DataEdit["StockOutTransId"];
      ParamValues.value.fromStoreId = DataEdit["FromStoreId"];
      ParamValues.value.toStoreId = DataEdit["ToStoreId"];
      ParamValues.value.StockWOTransTMId = DataEdit["RefId"];
      ParamValues.value.EntityId = ObjOperationId.value.EntityId;
      ParamValues.value.OperationId = ObjOperationId.value.UpdateId;
      ParamValues.value.storebranchmapid = Number(
        routes.query.storebranchmapid
      );
      ParamValues.value.ToStoreBrMapId = DataEdit["ToStoreBrMapId"];

      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "DirectIssue",
        },
      });
    }

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    // Debounced search for server-side filtering
    function SearchBox(value) {
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;
        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.fromStoreId;
        const columnName1 = filterItems.value.tostoreId ? "ToStore" : "";
        const columnValue1 = filterItems.value.tostoreId
          ? filterItems.value.tostoreId
          : "";
        const columnName2 = filterItems.value.requestCode ? "RefNo" : "";
        const columnValue2 = filterItems.value.requestCode
          ? filterItems.value.requestCode
          : "";
        const columnName3 = filterItems.value.issueCode ? "DocNo" : "";
        const columnValue3 = filterItems.value.issueCode
          ? filterItems.value.issueCode
          : "";
        const columnName4 = filterItems.value.issueby ? "Createdby" : "";
        const columnValue4 = filterItems.value.issueby
          ? filterItems.value.issueby
          : "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        const columnValue5 = TransferFlag == "1" ? 0 : "";

        if (columnValue5 === "") {
          Condition += " AND (sm.IsApproved IN (0, 1))";
        } else {
          Condition += " AND sm.IsApproved = " + columnValue5;
        }

        let response = await Service.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          "10,11,22",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          columnName4,
          columnValue4,
          Flag,
          searchOption,
          Condition
        );

        response["result"] = response["result"].filter(
          (x) => x.HospitalId == usersData.OrganizationId
          //x.BranchId == usersData.BranchId
        );

        items.value = response["result"];

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
        localStorage.removeItem("TransferFlag");
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = "StoreId";
        const columnValue = ParamValues.value.fromStoreId;
        const columnName1 = filterItems.value.tostoreId ? "ToStore" : "";
        const columnValue1 = filterItems.value.tostoreId
          ? filterItems.value.tostoreId
          : "";
        const columnName2 = filterItems.value.requestCode ? "RefNo" : "";
        const columnValue2 = filterItems.value.requestCode
          ? filterItems.value.requestCode
          : "";
        const columnName3 = filterItems.value.issueCode ? "DocNo" : "";
        const columnValue3 = filterItems.value.issueCode
          ? filterItems.value.issueCode
          : "";
        const columnName4 = filterItems.value.issueby ? "Createdby" : "";
        const columnValue4 = filterItems.value.issueby
          ? filterItems.value.issueby
          : "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await Service.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          "10,11",
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          columnName4,
          columnValue4,
          Flag,
          searchOption,
          Condition
        );

        response["result"] = response["result"].filter(
          (x) => x.HospitalId == usersData.OrganizationId
          // x.BranchId == usersData.BranchId
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    async function IsDelete(DataEdit) {
      debugger;
      console.log(StockOutTransId);
      try {
        const response = await Service.DeleteStockOutTM(StockOutTransId);
        console.log(response["result"]);
        let msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    }

    const ParamVal = ref({
      requestId: "",
      StockOutTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 3,
      status: ParamValues.value.status,
      Types: ParamValues.value.Types,
      StockTransId: 0,
    });

    async function IssueReturn(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamVal.value.requestId = data["DocNo"];
      ParamVal.value.StockTransId = data["StockTransId"];

      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamVal.value),
          param: "IssueReturn",
        },
      });
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.StockOutTransId;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    async function CampClose(ObjData) {
      debugger;
      try {
        const response = await Service.UpdateCampIssueClose(StockOutTransId);
        console.log(response["result"]);
        let msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          toast.add({
            severity: "success",
            summary: "Success",
            detail: "Issue closed successfully",
            life: 3000,
          });
          CampconfirmModel.value = false;
          IsShow();
        } else {
          toast.add({
            severity: "warn",
            summary: "Warning",
            detail: "Somthing went wrong",
            life: 3000,
          });
          CampconfirmModel.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    }

    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      ToStore: "",
      tostoreId: "",
      requestCode: "",
      issueby: "",
      issueCode: "",
      issuebyName: "",
    });

    let emitedfilterItems = ref({
      ToStore: "",
      tostoreId: "",
      requestCode: "",
      issueCode: "",
      recby: "",
      issueby: "",
      issuebyName: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    const EmitToStore = (data) => {
      emitedfilterItems.value.ToStore = data;
    };

    const EmitToStoreId = (data) => {
      emitedfilterItems.value.tostoreId = data;
    };
    const EmitToissuebyname = (data) => {
      // alert(data)
      emitedfilterItems.value.issuebyName = data;
    };
    const Emitrequestcode = (data) => {
      emitedfilterItems.value.requestCode = data;
    };
    const Emitissuesby = (data) => {
      emitedfilterItems.value.issueby = data;
    };

    const Emitissuecode = (data) => {
      emitedfilterItems.value.issueCode = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      // filterItems.value.LineOfBusiness = ServiceTypeNames;
      // filterItems.value.Type = TaskTypeNames;
      filterItems.value.ToStore = emitedfilterItems.value.ToStore;
      filterItems.value.issueby = emitedfilterItems.value.issueby;

      filterItems.value.tostoreId = emitedfilterItems.value.tostoreId;
      filterItems.value.requestCode = emitedfilterItems.value.requestCode;
      filterItems.value.issueCode = emitedfilterItems.value.issueCode;
      filterItems.value.issuebyName = emitedfilterItems.value.issuebyName;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 4;
      filterItems.value.tostoreId = "";
      filterItems.value.requestCode = "";
      filterItems.value.issueCode = "";
      filterItems.value.issuebyName = "";
      filterItems.value.issueby = "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "issueCode") {
        removechipvalue.value = 1;
      } else if (data == "requestCode") {
        removechipvalue.value = 2;
      } else if (data == "ToStore") {
        filterItems.value.tostoreId = "";
        removechipvalue.value = 3;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    return {
      EmitToissuebyname,
      Emitissuesby,
      showitemfield,
      items,
      headers,
      paramValue,
      onRowClick,
      IsShow,
      IsEdit,
      IsDelete,
      IsCreate,
      loading1,
      globalFilterFields,
      filters,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      CampconfirmModel,
      RowClick,
      DataEdit,
      IssueReturn,
      ParamValues,
      rowsCount,
      state,
      issueType,
      loading,
      paramValues1,
      itemListed,
      menus,
      toggle,
      menu,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitToStore,
      EmitToStoreId,
      Emitrequestcode,
      Emitissuecode,
      removeChip,
      removechipvalue,
      SearchBox,
      ShowRows,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      windowWidth,
      visible,
      CampClose,
    };
  },
});
</script>

<style>
.CampName {
  font-size: 14px;
  color: #2a9f0a;
}

.CampIssueClose {
  font-size: 14px;
  color: #e65f11;
}
</style>
